module.exports = __webpack_public_path__ + "media/images/temp/accordion-image-4-a819ed5e08b0d19988e4d9b987034ada.png";